"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VDraggableModal = void 0;
var react_1 = __importStar(require("react"));
var lodash_1 = require("lodash");
var DraggableModalContext_1 = require("./DraggableModalContext");
var DraggableModalInner_1 = require("./DraggableModalInner");
var draggableModalReducer_1 = require("./draggableModalReducer");
var utils_1 = require("./utils");
var VDraggableModal = function (props) {
    var _a = (0, react_1.useState)((0, lodash_1.uniqueId)()), id = _a[0], setId = _a[1];
    var modalProvider = (0, react_1.useContext)(DraggableModalContext_1.DraggableModalContext);
    if (!modalProvider) {
        throw new Error('No Provider');
    }
    var dispatch = modalProvider.dispatch, state = modalProvider.state;
    (0, react_1.useEffect)(function () {
        setId((0, lodash_1.uniqueId)());
    }, []);
    var modalState = (0, react_1.useMemo)(function () {
        return (0, draggableModalReducer_1.getModalState)(state, id, (0, utils_1.getNumberMatch)(props.height, 'height'), (0, utils_1.getNumberMatch)(props.width, 'width'));
    }, [state, props.height, props.width]);
    return (react_1.default.createElement(DraggableModalInner_1.DraggableModalInner, __assign({ id: id, dispatch: dispatch, modalState: modalState }, props)));
};
exports.VDraggableModal = VDraggableModal;
